<template>
    <button class="stb-button is-clearfix" :class="[{'stb-button-full-width': fullWidth}, type, {'disabled' : disabled}]">
        <i class="stb-button-icon icon is-pulled-left" :class="icon" v-if="icon"></i>
        <div class="stb-button-text is-pulled-right" v-if="name">{{name}}</div>
    </button>
</template>

<script>
// ion-ios-search
export default {
    name: 'stb-button',
    props: {
        icon: String,
        name: String,
        fullWidth: Boolean,
        type: "", // can be "secondary" or "danger"
        disabled: {
            type: Boolean,
            default: false,
        }
    },
}
</script>

<style lang="scss" scoped>
.stb-button {
    display: inline-block;
    background: $primary-color;
    color: $primary-text-color;
    max-width: 100%;
    outline: none;
    cursor: pointer;
    font-size: inherit;
    font-family: inherit;
    border: 0;
    @include border-radius();
    @include drop-shadow();
    padding: 0.6em 1em;
    min-width: 6em;
    font-size: 14px;
    vertical-align: middle;
    transition: all 0.14s ease;

    .stb-button-icon {
        font-size: 25px;
        /*padding: 20px;*/
        padding-left: 10px;
    }
    .stb-button-text {
        display: inline-block;

        text-transform: uppercase;
    }

    &.stb-button-full-width {
        width: 100%;
        max-width: 100%;
    }
}

.stb-button:hover {
    transform: translateY(2px);
}

.stb-button:active {
    transform: translateY(2px) scale(0.98,0.98);
}

.secondary {
    background-color: $darker-bg-color;
}

.danger {
    background-color: red;
}

</style>



// WEBPACK FOOTER //
// src/components/general/button.vue